import classNames from 'classnames';

const colorOptions = {
  gray: 'bg-gray-100 text-gray-800',
  red: 'bg-red-100 text-red-800',
  primary: 'bg-primary text-white',
  orange: 'text-white bg-[#FF914D]',
};

const sizeOptions = {
  xl: 'px-4 py-2 text-sm',
  '2xl': 'px-5 py-2.5 text-sm',
};

type ButtonGroupType = {
  label: string;
  value: string;
  onClick?: () => void;
};

interface Props {
  buttons: ButtonGroupType[];
  color?: keyof typeof colorOptions;
  size?: keyof typeof sizeOptions;
  selectedValue: string;
}

export const ButtonGroupComponent = ({
  buttons,
  color = 'gray',
  selectedValue,
  size = 'xl',
}: Props) => {
  return (
    <span className="isolate inline-flex rounded-md border border-gray-200 shadow-sm">
      {buttons.map((button, index) => {
        if (index === 0) {
          return (
            <button
              key={index}
              type="button"
              aria-label={button?.label}
              onClick={button.onClick}
              className={classNames(
                'relative inline-flex items-center rounded-l-md text-sm ',
                selectedValue === button.value && colorOptions[color],
                selectedValue === button.value ? 'font-bold' : 'font-normal',
                sizeOptions[size],
              )}
            >
              {button.label}
            </button>
          );
        }

        if (index === buttons.length - 1) {
          return (
            <button
              key={index}
              type="button"
              aria-label={button?.label}
              onClick={button.onClick}
              className={classNames(
                'relative -ml-px inline-flex items-center rounded-r-md font-medium focus:z-10',
                selectedValue === button.value && colorOptions[color],
                selectedValue === button.value ? 'font-bold' : 'font-normal',
                sizeOptions[size],
              )}
            >
              {button.label}
            </button>
          );
        }

        return (
          <button
            key={index}
            type="button"
            aria-label={button?.label}
            onClick={button.onClick}
            className={classNames(
              'relative -ml-px inline-flex items-center font-medium focus:z-10',
              selectedValue === button.value && colorOptions[color],
              selectedValue === button.value ? 'font-bold' : 'font-normal',
              sizeOptions[size],
            )}
          >
            {button.label}
          </button>
        );
      })}
    </span>
  );
};
